import User from '@mds/icons/User';
import { useContext } from 'react';
import { UserForAppBar } from '../../../utils/userName';
import { AccountMenuItemButton, AccountMenuItemButtonProps } from '../AccountMenuItem';
import { AccountMenuContext } from './context';

/**
 * Link to manage user's Neon account.
 *
 * Not shown when the user is logged out.
 */
export function NeonAccountLink({
  url = '/dashboard/manage-account',
  user: userProp,
  ...rest
}: {
  /**
   * Customise url (Neon Dashboard by default)
   */
  url?: string;
  /**
   * Defaults to user prop passed to <AppBarLayout>
   */
  user?: UserForAppBar | undefined;
} & Partial<AccountMenuItemButtonProps>) {
  const accountMenuContext = useContext(AccountMenuContext)!;
  const user = userProp ?? accountMenuContext.user;

  if (!user) {
    return null;
  }

  return (
    <AccountMenuItemButton icon={<User />} component="a" href={url} {...rest}>
      Manage Account
    </AccountMenuItemButton>
  );
}
